import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
  name: "error",
  initialState: {
    isErrorModalVisible: false,
    errorMessage: "",
    errorType: "kyc_error"
  },
  reducers: {
    setErrorModal: (state, { payload }) => {
      state.isErrorModalVisible = payload.show;
      state.errorMessage = payload.message;
      state.errorType = payload.errorType || "";
    },
  },
});

export const {
  setErrorModal,
} = errorSlice.actions;

export default errorSlice.reducer;
